module.exports = __webpack_public_path__ + "img/wuyou_xiangqing_erjian.112a5cc2.png";